import { DASHBOARD_LOJAS_EXCLUIDAS, dashboardLojaOptions } from '../../shared/lojaOptions';

const onlyDigits = (value, maxLength) => String(value || '').replace(/\D/g, '').slice(0, maxLength);

const formatDateInputValue = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const getOneMonthAgoDate = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 1);
  return formatDateInputValue(date);
};

const ordenarPorOptions = [
  'NumeroCarga',
  'ProtocoloCarga',
  'CodigoCarga',
  'SituacaoCarga',
  'NumeroPedido',
  'ProtocoloPedido',
  'CodigoPedido',
  'DataAgendamentoPedido',
  'PlacaVeiculo',
  'NumeroFrota',
  'TipoVeiculo',
  'DescricaoModeloVeicular',
  'NomeRemetente',
  'CNPJRemetente',
  'NomeDestinatario',
  'CNPJDestinatario',
  'Loja',
  'CidadeDestinatario',
  'UFDestinatario',
  'NomeTomador',
  'CNPJTomador',
  'PlacasReboque',
  'FrotasReboque',
  'ModelosReboque',
  'DataCriacaoPedido',
  'DataCriacaoCarga',
  'DataCarregamentoPedido',
  'InfoMotorista',
  'NomeResponsavel',
  'DataAgendamentoDescarga',
  'ChegadaDescarga',
  'SaidaDescarga',
  'ObservacoesDescarga',
  'DescricaoPosicaoAngellira',
  'CodigoViagemAngellira',
  'DescricaoTipoOperacao',
  'CodigoTipoOperacao',
  'DataInicialEsperaDescarga',
  'TempoEsperaDescarga',
  'TempoEsperaSegundos',
  'Ativo',
  'StatusViagemAngellira',
  'ViagemDataCadastroAngellira',
  'ClienteDistanciaAngellira',
  'ClienteTempoPrevChegadaAngellira',
  'ClienteAtualPrevChegadaAngellira',
  'ClienteAtualPrevSaidaAngellira',
  'TranspSequenciaAngellira',
  'ChegadaAngellira',
  'SaidaAngellira'
].map(value => ({
  value,
  label: value
}));

const getOptionsByValues = (options, values) => options.filter(option => values.includes(option.value));
const getOptionsByValuesInOrder = (options, values) => values
  .map(value => options.find(option => option.value === value))
  .filter(Boolean);

const lojaExcetoOptions = dashboardLojaOptions.filter(option => DASHBOARD_LOJAS_EXCLUIDAS.includes(String(option.value)));

const situacaoCargaOptions = [
  { value: '0', label: 'Não classificada' },
  { value: '1', label: 'Nova carga' },
  { value: '2', label: 'Cálculo de Frete' },
  { value: '3', label: 'Em andamento ?' },
  { value: '4', label: 'Aguardando Transportador' },
  { value: '5', label: 'Aguardando Notas Fiscais' },
  { value: '6', label: 'Pendências na Emissão' },
  { value: '7', label: 'Aguardando Impressão dos Documentos' },
  { value: '8', label: 'Pronto para o Transporte' },
  { value: '9', label: 'Em Transporte' },
  { value: '10', label: 'Pagamento liberado' },
  { value: '11', label: 'Finalizada' },
  { value: '13', label: 'Cancelada' },
  { value: '15', label: 'Aguardando Integração' },
  { value: '17', label: 'Em Transbordo' },
  { value: '18', label: 'Anulada' }
];

const statusViagemAngelliraOptions = [
  'Agendamento',
  'Iniciada',
  'Finalizada',
  'Cancelada',
  'Inexistente'
].map(value => ({
  value,
  label: value
}));

const ufDestinatarioOptions = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG',
  'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
].map(value => ({
  value,
  label: value
}));

const tipoOperacaoOptions = [
  { value: '3', label: '3 - HAVAN DISTRIBUICAO' },
  { value: '333', label: '333 - HAVAN DISTRIBUICAO BITREM' },
  { value: '508', label: '508 - HAVAN TRANSBORDO' },
  { value: '864', label: '864 - HAVAN OPERACAO ESTATUA' },
  { value: '1515', label: '1515 - RETORNO DE GAIOLA' },
  { value: '1689', label: '1689 - RETORNO DE GAIOLA - MISTO' },
  { value: '1690', label: '1690 - RETORNO DE GAIOLA - 1515' },
  { value: '1691', label: '1691 - RETORNO DE GAIOLA - 1212' }
];

const tipoVeiculoOptions = [
  { value: 'Próprio', label: 'Próprio' },
  { value: 'Terceiro', label: 'Terceiro' }
];

const defaultOrdenarPor = getOptionsByValuesInOrder(ordenarPorOptions, ['TempoEsperaSegundos', 'ChegadaDescarga']);
const defaultLojaExceto = getOptionsByValues(lojaExcetoOptions, DASHBOARD_LOJAS_EXCLUIDAS);
const defaultCodigoSituacaoCarga = getOptionsByValues(situacaoCargaOptions, ['4', '8', '9', '10', '15', '17', '3']);
const defaultCodigoTipoOperacao = getOptionsByValues(tipoOperacaoOptions, ['3', '333', '508', '864']);
const defaultStatusViagemAngellira = getOptionsByValues(statusViagemAngelliraOptions, ['Iniciada', 'Agendamento']);

const buildFiltroPreenchimento = (id, label) => ({
  id,
  type: 'select',
  label,
  placeholder: 'Selecione...',
  advanced: false,
  options: [
    { value: '', label: 'Todos' },
    { value: 'true', label: 'Preenchida' },
    { value: 'false', label: 'Não preenchida' }
  ]
});

const buildFiltroBooleano = (id, label) => ({
  id,
  type: 'select',
  label,
  placeholder: 'Selecione...',
  advanced: false,
  options: [
    { value: '', label: 'Todos' },
    { value: 'true', label: 'Sim' },
    { value: 'false', label: 'Não' }
  ]
});

export const filterConfig = [
  {
    id: 'Ativo',
    type: 'select',
    label: 'Ativo',
    placeholder: 'Selecione...',
    defaultValue: 'true',
    options: [
      { value: 'true', label: 'Sim' },
      { value: 'false', label: 'Não' }
    ]
  },
  {
    id: 'OrdenarPor',
    type: 'searchSelect',
    label: 'Ordenar Por',
    placeholder: 'Selecione uma ou mais colunas',
    isMulti: true,
    showSelectAll: true,
    options: ordenarPorOptions,
    defaultValue: defaultOrdenarPor
  },
  {
    id: 'NumeroCarga',
    type: 'text',
    label: 'Numero Carga',
    placeholder: 'Digite o numero da carga',
    advanced: false
  },
  {
    id: 'Loja',
    type: 'searchSelect',
    label: 'Loja',
    placeholder: 'Selecione as lojas',
    isMulti: true,
    showSelectAll: true,
    options: dashboardLojaOptions,
    advanced: false
  },
  {
    id: 'LojaExceto',
    type: 'searchSelect',
    label: 'Loja Exceto',
    placeholder: 'Selecione lojas para excluir',
    isMulti: true,
    showSelectAll: true,
    options: lojaExcetoOptions,
    defaultValue: defaultLojaExceto
  },
  {
    id: 'CodigoTipoOperacao',
    type: 'searchSelect',
    label: 'Tipo de Operação',
    placeholder: 'Selecione os tipos de operação',
    isMulti: true,
    showSelectAll: true,
    options: tipoOperacaoOptions,
    defaultValue: defaultCodigoTipoOperacao,
    advanced: false
  },
  {
    id: 'NumeroFrota',
    type: 'text',
    label: 'Numero Frota',
    placeholder: 'Digite o numero da frota',
    advanced: false
  },
  {
    id: 'TipoVeiculo',
    type: 'searchSelect',
    label: 'Tipo Veículo',
    placeholder: 'Selecione o tipo de veículo',
    isMulti: true,
    showSelectAll: true,
    options: tipoVeiculoOptions,
    advanced: false
  },
  buildFiltroBooleano('DataAgendamentoManual', 'Agendamento Manual'),
  buildFiltroBooleano('ChegadaManual', 'Chegada Manual'),
  buildFiltroBooleano('SaidaManual', 'Saida Manual'),
  buildFiltroBooleano('DescargaManual', 'Descarga Manual'),
  {
    id: 'ChegouForaJanela',
    type: 'select',
    label: 'Chegou fora da janela',
    placeholder: 'Selecione...',
    advanced: true,
    options: [
      { value: 'true', label: 'Sim' },
      { value: 'false', label: 'Não' }
    ]
  },
  {
    id: 'SituacaoCarga',
    type: 'text',
    label: 'Situação da Carga',
    placeholder: 'Digite a situação da carga'
  },
  {
    id: 'CodigoSituacaoCarga',
    type: 'searchSelect',
    label: 'Código da Situação da Carga',
    placeholder: 'Selecione a situação da carga',
    isMulti: true,
    showSelectAll: true,
    options: situacaoCargaOptions,
    defaultValue: defaultCodigoSituacaoCarga
  },
  {
    id: 'StatusViagemAngellira',
    type: 'searchSelect',
    label: 'Status da Viagem Angellira',
    placeholder: 'Selecione o status da viagem',
    isMulti: true,
    showSelectAll: true,
    options: statusViagemAngelliraOptions,
    defaultValue: defaultStatusViagemAngellira
  },
  {
    id: 'Direcao',
    type: 'select',
    label: 'Direção',
    placeholder: 'Selecione...',
    defaultValue: 'desc',
    options: [
      { value: 'asc', label: 'Ascendente' },
      { value: 'desc', label: 'Descendente' }
    ]
  },
  {
    id: 'NumeroPedido',
    type: 'text',
    label: 'Número do Pedido',
    placeholder: 'Digite o numero do pedido'
  },
  {
    id: 'DataAgendamentoPedidoInicio',
    type: 'date',
    label: 'Agendamento Pedido Início'
  },
  {
    id: 'DataAgendamentoPedidoFim',
    type: 'date',
    label: 'Agendamento Pedido Fim'
  },
  {
    id: 'PlacaVeiculo',
    type: 'text',
    label: 'Placa do Veículo',
    placeholder: 'Digite a placa do veiculo'
  },
  {
    id: 'DescricaoModeloVeicular',
    type: 'text',
    label: 'Modelo Veicular',
    placeholder: 'Digite o modelo veicular'
  },
  {
    id: 'NomeRemetente',
    type: 'text',
    label: 'Remetente',
    placeholder: 'Digite o nome do remetente'
  },
  {
    id: 'CNPJRemetente',
    type: 'text',
    label: 'CNPJ Remetente',
    placeholder: 'Digite o CNPJ do remetente',
    sanitizeValue: (value) => onlyDigits(value, 14)
  },
  {
    id: 'NomeDestinatario',
    type: 'text',
    label: 'Destinatário',
    placeholder: 'Digite o nome do destinatário'
  },
  {
    id: 'CNPJDestinatario',
    type: 'text',
    label: 'CNPJ Destinatário',
    placeholder: 'Digite o CNPJ do destinatário',
    sanitizeValue: (value) => onlyDigits(value, 14)
  },
  {
    id: 'CidadeDestinatario',
    type: 'text',
    label: 'Cidade Destinatário',
    placeholder: 'Digite a cidade do destinatario',
    advanced: true
  },
  {
    id: 'UFDestinatario',
    type: 'searchSelect',
    label: 'UF Destinatário',
    placeholder: 'Selecione a UF do destinatário',
    isMulti: true,
    showSelectAll: true,
    options: ufDestinatarioOptions,
    advanced: true
  },
  {
    id: 'PlacasReboque',
    type: 'text',
    label: 'Placas Reboque',
    placeholder: 'Digite as placas de reboque'
  },
  {
    id: 'FrotasReboque',
    type: 'text',
    label: 'Frotas Reboque',
    placeholder: 'Digite as frotas de reboque'
  },
  {
    id: 'ModelosReboque',
    type: 'text',
    label: 'Modelos Reboque',
    placeholder: 'Digite os modelos de reboque'
  },
  {
    id: 'DataCriacaoPedidoInicio',
    type: 'date',
    label: 'Criação Pedido Início',
    defaultValue: getOneMonthAgoDate()
  },
  {
    id: 'DataCriacaoCargaInicio',
    type: 'date',
    label: 'Criação Carga Início'
  },
  {
    id: 'DataCriacaoCargaFim',
    type: 'date',
    label: 'Criacao Carga Fim'
  },
  {
    id: 'InfoMotorista',
    type: 'text',
    label: 'Informações do Motorista',
    placeholder: 'Digite informações do motorista'
  },
  {
    id: 'NomeResponsavel',
    type: 'text',
    label: 'Responsável',
    placeholder: 'Digite o nome do responsável'
  },
  {
    id: 'DataAgendamentoDescargaInicio',
    type: 'date',
    label: 'Agendamento Descarga Início'
  },
  {
    id: 'DataAgendamentoDescargaFim',
    type: 'date',
    label: 'Agendamento Descarga Fim'
  },
  buildFiltroPreenchimento('PossuiDataAgendamentoDescarga', 'Ag. Descarga Preenchida'),
  {
    id: 'ChegadaDescargaInicio',
    type: 'date',
    label: 'Chegada Descarga Início'
  },
  {
    id: 'ChegadaDescargaFim',
    type: 'date',
    label: 'Chegada Descarga Fim'
  },
  buildFiltroPreenchimento('PossuiChegadaDescarga', 'Chegada Descarga Preenchida'),
  {
    id: 'SaidaDescargaInicio',
    type: 'date',
    label: 'Saída Descarga Início'
  },
  {
    id: 'SaidaDescargaFim',
    type: 'date',
    label: 'Saída Descarga Fim'
  },
  buildFiltroPreenchimento('PossuiSaidaDescarga', 'Saída Descarga Preenchida'),
  {
    id: 'ObservacoesDescarga',
    type: 'text',
    label: 'Observações da Descarga',
    placeholder: 'Digite observações da descarga',
    fullWidth: true
  },
  {
    id: 'DescricaoPosicaoAngellira',
    type: 'text',
    label: 'Posição Angellira',
    placeholder: 'Digite a posição Angellira'
  },
  {
    id: 'CodigoViagemAngellira',
    type: 'text',
    label: 'Código da Viagem Angellira',
    placeholder: 'Digite o código da viagem'
  }
];

export { listagemConfig } from './listagemConfig';
